<template>
    <v-container fluid class="pa-0">
        <v-row>
            <v-col cols="12">
                <div class="gt-tag">
                    <div class="gt-tag-bg forum"></div>
                    <div class="gt-tag-text">
                        <h4 class="d-flex align-center justify-center">
                            <v-icon color="white" class="mr-1">mdi-frequently-asked-questions</v-icon>Suporte
                        </h4>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" md="6">
                <h1 style="
                    font-family: Inter;
                    font-weight: bold;
                    color: #707070;
                    line-height: 1;
                    font-size: 1.8rem;
                    text-align: left;
                ">
                F<span style="color: #f57029">A</span>Q
                </h1>
            </v-col>
            <v-col cols="12">
                <v-expansion-panels>
                    <v-expansion-panel
                    v-for="item in faq"
                    :key="item.question"
                    >
                    <v-expansion-panel-header>
                        {{ item.question }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        {{ item.answer }}
                    </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
            <v-col cols="12" md="6">
                <h1 style="
                    font-family: Inter;
                    font-weight: bold;
                    color: #707070;
                    line-height: 1;
                    font-size: 1.8rem;
                    text-align: left;
                ">
                entre em<span style="color: #f57029"> Contato</span>
                </h1>
            </v-col>
            <v-col cols="12">
                <v-form>
                    <v-text-field
                    v-model="name"
                    placeholder="Nome"
                    disabled
                    ></v-text-field>
                    <v-text-field
                    v-model="email"
                    placeholder="Email"
                    disabled
                    ></v-text-field>
                    <v-textarea
                    v-model="message"
                    placeholder="Digite sua mensagem"
                    ></v-textarea>
                    <v-btn text @click="sendMessage" style="
						background-color: #f15a24;
						color: #ffffff;
						text-transform: none;">Enviar</v-btn>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    name: 'Suporte',
    data() {
        return {
            confirmSend: false,
            name: this.$store.state.user.first_name + ' ' + this.$store.state.user.last_name,
            email: this.$store.state.user.email,
            message: '',
            faq: [
                {
                    question: 'O que é o myLegis e como funciona?',
                    answer: 'A rede social de Leis é uma plataforma online que permite que os usuários discutam, compartilhem e aprendam sobre leis e regulamentações. O aplicativo facilita a interação entre pessoas interessadas em questões legais, oferecendo recursos como fóruns de discussão, grupos temáticos e conteúdo educativo.',
                },
                {
                    question: 'Quais são os recursos principais do aplicativo myLegis?',
                    answer: 'O aplicativo oferece recursos como fóruns de discussão, onde os usuários podem fazer perguntas e compartilhar conhecimento jurídico. Além disso, há grupos temáticos para reunir pessoas com interesses legais específicos. O aplicativo também fornece acesso a atualizações legais e conteúdo educativo sobre diferentes áreas do direito.',
                },
                {
                    question: 'Como posso encontrar e me conectar com outros membros da comunidade?',
                    answer: 'Para encontrar e se conectar com outros membros da comunidade legal, você pode usar a função de pesquisa para encontrar grupos e pessoas com interesses semelhantes. Além disso, o aplicativo permite que você convide amigos e colegas para se juntarem à plataforma e participarem das discussões.',
                },
                {
                    question: 'É seguro discutir casos legais pessoais ou informações confidenciais?',
                    answer: 'Não é recomendável discutir casos legais pessoais ou informações confidenciais no aplicativo. A rede social de Leis é destinada a discussões gerais e compartilhamento de conhecimento jurídico. Casos legais individuais devem ser tratados com um advogado licenciado para garantir a confidencialidade e o aconselhamento adequado.',
                },
                {
                    question: 'O myLegis está disponível em dispositivos móveis?',
                    answer: 'Sim, o aplicativo de rede social de Leis está disponível para dispositivos móveis, como smartphones e tablets. Você pode acessa-los em qualquer navegador.',
                }
            ]
        }
    },
    methods: {
        sendMessage() {
            let msg = {
                mensagem: this.message
            }
            this.$http.post("items/suporte", msg)
        }
    }
}
</script>